import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Key, ProductConfigName } from '@oy/types/src/Config/FrontendConfig';
import { useState } from 'react';
import { useFrontendConfigs } from 'src/hooks/useFrontendConfig';

export const useApiDisburseListActionButton = () => {
  const { getConfigAsBoolean } = useFrontendConfigs();
  const showVendorMaintenance = getConfigAsBoolean(
    ProductConfigName.API_DISBURSE,
    Key.SHOW_VENDOR_MAINTENANCE,
  );

  const [showSideModal, setShowSideModal] = useState(false);

  const handleToggleSideModal = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_bank_maintenance_button,
      {
        click_from: 'api_disburse_list',
      },
    );
    setShowSideModal(!showSideModal);
  };

  return { showVendorMaintenance, showSideModal, handleToggleSideModal };
};
